import { saveEHRAppointment } from '@ax/service';
import { SaveEHRAppointmentInput } from '@ax/service/src/ehr-interface';
import { useMutation } from '@tanstack/react-query';

export function useSaveEHRAppointmentApi() {
  const saveEHRAppointmentMutation = useMutation({
    mutationKey: ['save-ehr-appointment'],
    mutationFn: (data: SaveEHRAppointmentInput) => saveEHRAppointment(data),
    onError: (error: any) => {
      return error;
    },
  });

  return saveEHRAppointmentMutation;
}
